import { makeStyles, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientConfig } from '../../../clientConfig';
import { formatPhoneNumber } from '../../../utils/formatPhoneNumber';
import { ClientConfigContext } from '../../clientConfigContext';
import PromptCard from './PromptCard';

type ClosableCustomerServiceCardProps = {
    closeUrl?: string;
    onClose?: () => void;
    onLinkClick?: () => void;
    variant?: 'closable';
};

type DefaultCustomerServiceCardProps = {
    onLinkClick?: () => void;
    variant?: 'default';
};

type CustomerServiceCardProps = ClosableCustomerServiceCardProps | DefaultCustomerServiceCardProps;

const useStyles = makeStyles(() => ({
    text: {
        display: 'inline',
    },
    link: {
        textDecoration: 'none',
    },
}));

const defaultProps: DefaultCustomerServiceCardProps = {
    variant: 'default',
};

const CustomerServiceCard = (props: CustomerServiceCardProps = defaultProps): JSX.Element => {
    const { customerSupportNumber } = useContext<ClientConfig>(ClientConfigContext);
    const { t } = useTranslation();
    const classes = useStyles();

    const handleLinkClick = () => {
        if (props.onLinkClick) {
            props.onLinkClick();
        }
    };

    return (
        <PromptCard
            title='Contact customer service'
            closeUrl={'closeUrl' in props ? props.closeUrl : undefined}
            variant={props.variant}
            onClose={'onClose' in props ? props.onClose : undefined}
        >
            <Typography className={classes.text} variant='body1'>
                {t('We could not verify your identity. To access your medical records, call customer service toll-free at')}
            </Typography>
            &nbsp;
            {
                <a href={'tel:' + customerSupportNumber} onClick={handleLinkClick} className={classes.link}>
                    {formatPhoneNumber(customerSupportNumber)}
                </a>
            }
            <Typography className={classes.text} variant='body1'>
                .
            </Typography>
        </PromptCard>
    );
};

export default CustomerServiceCard;
